import { useEffect, useState } from "react";

import "./CookieBanner.css";

const COOKIE_KEY = "trainosys_cookie_consent";

const updateGtagConsent = (granted) => {
  const status = granted ? "granted" : "denied";

  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: status,
      ad_user_data: status,
      ad_personalization: status,
      analytics_storage: status,
    });
  }
};

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);

    if (!consent) {
      setVisible(true);
      return;
    }

    updateGtagConsent(consent === "accepted");
  }, []);

  function saveConsent(value) {
    const isAccepted = value === "accepted";

    localStorage.setItem(COOKIE_KEY, value);
    updateGtagConsent(isAccepted);
    setVisible(false);
  }

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <div>
          <h4>Cookie Preferences</h4>
          <p>
            We use cookies to improve your browsing experience and analyze website traffic.
          </p>
        </div>

        <div className="cookie-actions">
          <button
            className="cookie-secondary"
            onClick={() => saveConsent("rejected")}
          >
            Reject
          </button>
          <button
            className="cookie-primary"
            onClick={() => saveConsent("accepted")}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
